<template lang="pug">
div(@click="$router.push({ name: 'opportunityTasks', params: { id: task.opportunity_id } })" class="tw-cursor-pointer")
  v-timeline-item(
    fill-dot
    medium
    :icon="this.$formatters.taskIcon(task.type)"
    color="white"
    :icon-color="this.$formatters.taskColor(task.status)"
  )
    v-row(dense align="start" justify="space-between" class="tw--ml-6")
      v-col
        v-row(no-gutters)
          v-col
            v-row(no-gutters)
              v-col(class=" tw-font-medium tw-text-gray-darken-3")
                router-link(
                  class="tw-font-medium text-link"
                  :to="{ name: 'opportunityTasks', params: { id: task.opportunity_id } }"
                ) {{ task.name }}
            v-row(no-gutters)
              v-col(class=" tw-text-sm")
                span(v-if="task.user") {{ task.user.name }}
      v-col(cols="auto pr-8")
        span(class="tw-font-medium tw-text-gray-darken-3") {{ this.$moment(task.completed_date).fromNow() }}
</template>

<script>
export default {
  props: {
    task: null,
  },
};
</script>

<style lang="stylus">
.v-timeline-item__dot
    box-shadow: none !important
    -webkit-box-shadow: none !important

.v-timeline-item__inner-dot
    border: 1px solid #f3f3f3
    border-radius: 50%
</style>
